import { useTranslation } from 'react-i18next'
import { FilterField, FilterOperator } from './filterTypes'
import { getOperatorsForType } from './filterUtils'

interface FilterOperatorSelectorProps {
  field: FilterField
  onOperatorSelect: (operator: FilterOperator) => void
}

export function FilterOperatorSelector({ field, onOperatorSelect }: FilterOperatorSelectorProps) {
  const { t } = useTranslation()
  const availableOperators = getOperatorsForType(field.type)

  return (
    <>
      <div className="px-3 py-1 text-xs text-base-content/50 font-medium">
        {field.label}
      </div>
      {availableOperators.map((operator) => (
        <button
          key={operator}
          onClick={() => onOperatorSelect(operator)}
          className="w-full text-left px-3 py-2 text-sm hover:bg-base-200 transition-colors cursor-pointer"
        >
          {t(`fileExplorer.filters.operators.${operator}`)}
        </button>
      ))}
    </>
  )
}
